import {
  Outlet,
  useLocation,
} from "react-router-dom";

import useRemoteAssets from "../utils/useRemoteAssets";

export default function MobileLayout() {

  const location = useLocation();

  const isNotFoundPage =
    location.pathname === "/not-found";

  const success =
    location.pathname === "/success";
    const ASSETS = useRemoteAssets();

  if (!ASSETS) return <div>Loading assets...</div>;

  return (

    <div className="relative min-h-screen overflow-hidden bg-white">

      {/* Top Image */}

      <img
        src={ASSETS.top}
        className="absolute top-[-4rem] right-[-5rem] w-[14rem] md:top-[-7rem] md:right-[-10rem] md:w-[18rem] lg:top-[-8rem] lg:right-[-12rem] lg:w-[22rem] pointer-events-none object-contain"
      />

      {/* Bottom Image */}

      <img
        src={ASSETS.bottom}
        className="absolute bottom-0 left-[-0.5rem] w-[12rem] md:left-[-1rem] md:w-[14rem] lg:left-[-1.5rem] lg:w-[16rem] pointer-events-none object-contain"
      />

      {/* Header */}

      <div className="mt-[clamp(100px,18vh,160px)] flex justify-center items-center gap-3">

        <img
          src={ASSETS.logo}
          className="w-[clamp(40px,10vw,46px)] h-auto"
        />

        <div>

          <h1 className="text-[clamp(18px,5vw,24px)] font-normal leading-tight font-pattaya">

            Ambit Tech

          </h1>

          <p className="text-[clamp(9px,3vw,11px)] leading-tight">

            Innovate. Integrate. Elevate.

          </p>

        </div>
      </div>

      {/* Dynamic Content */}

      <div className="mt-[clamp(30px,6vh,50px)] px-[clamp(16px,6vw,38px)]">

        <Outlet />

      </div>

      {/* Footer Text */}

      {!isNotFoundPage && !success && (

        <p className="absolute bottom-[clamp(80px,10vh,90px)] w-full px-6 text-center text-[clamp(9px,3vw,10px)] leading-snug">

          Don't have a Login yet…!
          Just enter your Email ID
          and follow us.

          We ensure your Signup for
          a new account in few steps

        </p>

      )}

    </div>
  );
}